import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-form-field-error-messages',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './form-field-error-messages.component.html',
  styleUrl: './form-field-error-messages.component.scss',
  host: { style: 'display: contents;' },
})
export class FormFieldErrorMessagesComponent {
  @Input() formField?: AbstractControl | null;
}
